import { render } from "./ServiceCategoryHealthAndWelfare.vue?vue&type=template&id=7cc465ae&ts=true"
import script from "./ServiceCategoryHealthAndWelfare.vue?vue&type=script&lang=ts"
export * from "./ServiceCategoryHealthAndWelfare.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__